export default "__VITE_ASSET__DpTsbRGm__"